import { Packet } from "src/Interfaces/commonDtos";
import { postRequest } from "src/Requests/requestTemplates";
import { IPortfoCloneDTO } from "src/VirtualOMS/types/portfo";

export const clonePortfo = (dto: IPortfoCloneDTO): Promise<Packet<boolean>> =>
  postRequest("/v1/Portfo/Clone", dto);
